export default class Accessibility {
    constructor() {
    }

    static enableEnterKeyLinks(links) {
        links.forEach(link => {
            link.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    link.click();
                }
            });
        });
    }

    static enableKeyboardClick(elements) {
        elements.forEach(element => {
            element.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    element.click();
                }
            });
        });
    }

    static toggleExpandState(element) {
        const isExpanded = element.getAttribute('aria-expanded') === 'true';
        element.setAttribute('aria-expanded', !isExpanded);
    }

    static toggleAriaLabel(element, openText, closeText) {
        element.setAttribute(
            'aria-label', 
            element.getAttribute('aria-label') === openText ? closeText : openText
        );
    }

    enableArrowNavigation(tabList, tabs, { ariaExpandedOnFocus = false, initialTabFocus = 0 } = {}) {
        if (!tabList || !tabs.length) return;
        this.tabList = tabList;
        this.tabs = tabs;
        this.tabFocus = initialTabFocus;

        this.#setInitialTabIndex(initialTabFocus);

        tabList.addEventListener('keydown', (e) => 
            this.#processArrowKeyNav(e, { ariaExpandedOnFocus })
        );
    }

    #processArrowKeyNav(e, { ariaExpandedOnFocus = false }) {
        if (["ArrowRight", "ArrowLeft"].includes(e.key)) {
            this.tabs[this.tabFocus].setAttribute("tabindex", -1);
            if (ariaExpandedOnFocus) {
                this.tabs[this.tabFocus].setAttribute("aria-expanded", "false");
            }
            this.tabFocus = (e.key === "ArrowRight") 
                ? (this.tabFocus + 1) % this.tabs.length 
                : (this.tabFocus - 1 + this.tabs.length) % this.tabs.length;
    
            this.tabs[this.tabFocus].setAttribute("tabindex", 0);
            if (ariaExpandedOnFocus) {
                this.tabs[this.tabFocus].setAttribute("aria-expanded", "true");
            }
            this.tabs[this.tabFocus].focus();
        } else if (e.key == 'Enter' ) {
            this.tabs[this.tabFocus].click();
        }
        
    }

    #setInitialTabIndex(initialTabFocus) {
        this.tabs.forEach((tab, index) => {
            if (index === initialTabFocus) {
                tab.setAttribute("tabindex", 0);
            } else {
                tab.setAttribute("tabindex", -1);
            }
        });
    }

    

}